import { render, staticRenderFns } from "./xuanxing.vue?vue&type=template&id=6e0849be&scoped=true"
import script from "./xuanxing.vue?vue&type=script&lang=js"
export * from "./xuanxing.vue?vue&type=script&lang=js"
import style0 from "./xuanxing.vue?vue&type=style&index=0&id=6e0849be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0849be",
  null
  
)

export default component.exports